import clsx from '~/utils/clsx'
import { watchFunctionalComponent } from '~/utils/hyperactiv';
import { Title as TitleCN } from './title.css';

export default watchFunctionalComponent(function Title(p) {
  return <div class={clsx('title', TitleCN, p.cn)}>{p.options.text}</div>
})
